import React, { useState } from "react";
import { Box } from "@mui/system";
import { images } from "../../Images/Svg";
import VendorOnboarding from "./VendorOnboarding";
import { useNavigate } from "react-router";
import VendorDraft from "./VendorDraft";
const { backArrowBold, SavedIcon, AddVendorIcon } = images;

function VendorOnboardingMain() {
  const [isStepper, setIsStepper] = useState(false);
  const navigate = useNavigate();
  const onBackClick = () => {
    if (isStepper) setIsStepper(false);
    else navigate("/vendorManagement");
  };

  return (
    <Box sx={{ marginLeft: "0.9rem", marginTop: "2.5rem" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
          <img
            style={{ cursor: "pointer" }}
            src={backArrowBold}
            alt="backArrow"
            onClick={onBackClick}
          />
          <h1 style={{ fontSize: "1.6rem", fontWeight: 500, color: "#505050" }}>
            Add New Vendor
          </h1>
        </div>
        {!isStepper && (
          <div style={{ display: "flex" }}>
            <img src={SavedIcon} alt="alternateSavedIcon" />
            <img
              style={{ position: "relative", top: "-4px", cursor: "pointer" }}
              src={AddVendorIcon}
              alt="alternateAddVendorIcon"
              onClick={() => setIsStepper(true)}
            />
          </div>
        )}
      </div>
      <div style={{ marginTop: "3.5rem", marginLeft: "3rem" }}>
        {isStepper ? <VendorOnboarding /> : <VendorDraft />}
      </div>
    </Box>
  );
}

export default VendorOnboardingMain;
